import { render, staticRenderFns } from "./r-link.vue?vue&type=template&id=2f709d5f&scoped=true"
import script from "./r-link.vue?vue&type=script&lang=ts"
export * from "./r-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f709d5f",
  null
  
)

export default component.exports